'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sticky = exports.StickyContainer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _class2, _temp4;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _raf = require('raf');

var _raf2 = _interopRequireDefault(_raf);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('app:components:sticky');

var StickyContainer = exports.StickyContainer = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(StickyContainer, _PureComponent);

    function StickyContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StickyContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StickyContainer.__proto__ || (0, _getPrototypeOf2.default)(StickyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], _this.subscribers = [], _this.subscribe = function (handler) {
            _this.subscribers = _this.subscribers.concat(handler);
        }, _this.unsubscribe = function (handler) {
            _this.subscribers = _this.subscribers.filter(function (current) {
                return current !== handler;
            });
        }, _this.notifySubscribers = function (evt) {
            if (!_this.framePending) {
                var currentTarget = evt.currentTarget;


                (0, _raf2.default)(function () {
                    _this.framePending = false;

                    var _this$node$getBoundin = _this.node.getBoundingClientRect(),
                        top = _this$node$getBoundin.top,
                        bottom = _this$node$getBoundin.bottom;

                    log('sticky container: top=%d, bottom=%d', top, bottom);
                    _this.subscribers.forEach(function (handler) {
                        return handler({
                            distanceFromTop: top,
                            distanceFromBottom: bottom,
                            eventSource: currentTarget === window ? document.body : _this.node
                        });
                    });
                });
                _this.framePending = true;
            }
        }, _this.getParent = function () {
            return _this.node;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(StickyContainer, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                subscribe: this.subscribe,
                unsubscribe: this.unsubscribe,
                getParent: this.getParent
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.events.forEach(function (event) {
                return window.addEventListener(event, _this2.notifySubscribers);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this3 = this;

            this.events.forEach(function (event) {
                return window.removeEventListener(event, _this3.notifySubscribers);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement('div', (0, _extends3.default)({}, this.props, {
                ref: function ref(node) {
                    return _this4.node = node;
                },
                onScroll: this.notifySubscribers,
                onTouchStart: this.notifySubscribers,
                onTouchMove: this.notifySubscribers,
                onTouchEnd: this.notifySubscribers
            }));
        }
    }]);
    return StickyContainer;
}(_react.PureComponent), _class.childContextTypes = {
    subscribe: _propTypes2.default.func,
    unsubscribe: _propTypes2.default.func,
    getParent: _propTypes2.default.func
}, _temp2);
var Sticky = exports.Sticky = (_temp4 = _class2 = function (_Component) {
    (0, _inherits3.default)(Sticky, _Component);

    function Sticky() {
        var _ref2;

        var _temp3, _this5, _ret2;

        (0, _classCallCheck3.default)(this, Sticky);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp3 = (_this5 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Sticky.__proto__ || (0, _getPrototypeOf2.default)(Sticky)).call.apply(_ref2, [this].concat(args))), _this5), _this5.state = {
            isSticky: false,
            wasSticky: false,
            style: {}
        }, _this5.handleContainerEvent = function (_ref3) {
            var distanceFromTop = _ref3.distanceFromTop,
                distanceFromBottom = _ref3.distanceFromBottom,
                eventSource = _ref3.eventSource;

            var parent = _this5.context.getParent();

            var preventingStickyStateChanges = false;
            if (_this5.props.relative) {
                preventingStickyStateChanges = eventSource !== parent;
                distanceFromTop = -(eventSource.scrollTop + eventSource.offsetTop) + _this5.placeholder.offsetTop;
            }

            if (!_this5.content) return;
            var parentClientRect = parent.getBoundingClientRect();
            var placeholderClientRect = _this5.placeholder.getBoundingClientRect();
            var contentClientRect = _this5.content.getBoundingClientRect();
            var calculatedHeight = contentClientRect.height;

            var bottomDifference = distanceFromBottom - _this5.props.bottomOffset - calculatedHeight;

            log('parent height: %d, content height: %d', parentClientRect.height, contentClientRect.height);
            // if(parentClientRect.height === contentClientRect.height){
            //     preventingStickyStateChanges = true;
            // }

            var wasSticky = !!_this5.state.isSticky;

            var isSticky = preventingStickyStateChanges ? wasSticky : distanceFromTop <= -_this5.props.topOffset && distanceFromBottom > -_this5.props.bottomOffset;

            distanceFromBottom = (_this5.props.relative ? parent.scrollHeight - parent.scrollTop : distanceFromBottom) - calculatedHeight;

            var top = bottomDifference > 0 ? _this5.props.relative ? parent.offsetTop - parent.offsetParent.scrollTop : 0 : bottomDifference;

            //log('sticky: top=%d, distanceFromBottom=%d, calculatedHeight=%d', top, distanceFromBottom, calculatedHeight);
            var style = !isSticky ? {} : {
                position: 'fixed',
                top: top,
                left: placeholderClientRect.left,
                width: placeholderClientRect.width
            };

            if (!_this5.props.disableHardwareAcceleration) {
                style.transform = 'translateZ(0)';
            }

            _this5.setState({
                isSticky: isSticky,
                wasSticky: wasSticky,
                distanceFromTop: distanceFromTop,
                distanceFromBottom: distanceFromBottom,
                calculatedHeight: calculatedHeight,
                style: style
            });
        }, _temp3), (0, _possibleConstructorReturn3.default)(_this5, _ret2);
    }

    (0, _createClass3.default)(Sticky, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (!this.context.subscribe) throw new TypeError("Expected Sticky to be mounted within StickyContainer");

            this.context.subscribe(this.handleContainerEvent);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.context.unsubscribe(this.handleContainerEvent);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.placeholder.style.paddingBottom = this.props.disableCompensation ? 0 : (this.state.isSticky ? this.state.calculatedHeight : 0) + 'px';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var element = _react2.default.cloneElement(this.props.children({
                isSticky: this.state.isSticky,
                wasSticky: this.state.wasSticky,
                distanceFromTop: this.state.distanceFromTop,
                distanceFromBottom: this.state.distanceFromBottom,
                calculatedHeight: this.state.calculatedHeight,
                style: this.state.style
            }), { ref: function ref(content) {
                    _this6.content = _reactDom2.default.findDOMNode(content);
                } });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { ref: function ref(placeholder) {
                        return _this6.placeholder = placeholder;
                    } }),
                element
            );
        }
    }]);
    return Sticky;
}(_react.Component), _class2.propTypes = {
    topOffset: _propTypes2.default.number,
    bottomOffset: _propTypes2.default.number,
    relative: _propTypes2.default.bool,
    children: _propTypes2.default.func.isRequired
}, _class2.defaultProps = {
    relative: false,
    topOffset: 0,
    bottomOffset: 0,
    disableCompensation: false,
    disableHardwareAcceleration: false
}, _class2.contextTypes = {
    subscribe: _propTypes2.default.func,
    unsubscribe: _propTypes2.default.func,
    getParent: _propTypes2.default.func
}, _temp4);


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/components/sticky.js
// module id = 578
// module chunks = 0